// @spec SHL-STR-050
'use client';

import * as React from 'react';

/**
 * Organization branding data provided through context.
 */
export interface OrganizationBranding {
  /** URL to organization logo image */
  logoUrl: string | null;
  /** Organization display name */
  name: string;
  /** Custom primary color for Enterprise tier (hex format) */
  primaryColor: string | null;
  /** Custom favicon URL for Enterprise tier */
  faviconUrl: string | null;
  /** Whether the organization has Enterprise tier features */
  isEnterprise: boolean;
  /** Whether branding data is still loading */
  isLoading: boolean;
}

/**
 * Default branding values when no organization context is available.
 */
const defaultBranding: OrganizationBranding = {
  logoUrl: null,
  name: 'Quantifier',
  primaryColor: null,
  faviconUrl: null,
  isEnterprise: false,
  isLoading: true,
};

/**
 * Context for organization branding data.
 * Provides branding information to components throughout the application.
 */
export const OrganizationBrandingContext =
  React.createContext<OrganizationBranding>(defaultBranding);

OrganizationBrandingContext.displayName = 'OrganizationBrandingContext';
